module.exports = __webpack_public_path__ + "img/star-circle.7ad85fe7.svg";